import { createSelector } from '@reduxjs/toolkit';
import {
  selectFilterConfig,
  selectFilterValues,
  selectApplyFiltersVersion,
  selectDashboards,
} from './dashboardSlice';

export const selectCameraFilter = createSelector(
  [selectFilterConfig],
  (filterConfig) =>
    filterConfig.find(
      (f) => f.column === 'full_camera_id' || f.column === 'camera_id'
    ) || null
);

export const selectDashboardHasCameraFilter = createSelector(
  [selectCameraFilter, selectFilterValues, selectApplyFiltersVersion],
  (cameraFilter, filterValues, applyFiltersVersion) => {
    if (!cameraFilter || applyFiltersVersion === 0) return false;
    const cameraValue = filterValues[cameraFilter.id];
    const nullLabel = cameraFilter.allow_null
      ? cameraFilter.null_label
      : undefined;
    return !!(
      cameraValue &&
      cameraValue !== nullLabel &&
      cameraValue !== 'all' &&
      cameraValue !== ''
    );
  }
);

export const selectHeatmapPanelData = (dashboardId, panelKey) =>
  createSelector(
    [selectDashboards],
    (dashboards) => dashboards[dashboardId]?.panels?.[panelKey] || null
  );

export const selectHeatmapOptions = createSelector(
  [(state, chart) => chart],
  (chart) => {
    const [xAgg, yAgg] = String(chart.aggregate_by || '')
      .split(/[;,]/)
      .map((s) => s.trim());

    return {
      title: chart.title?.toUpperCase() || chart.name?.toUpperCase() || '',
      resizable: true,
      height: '400px',
      color: {
        gradient: {
          colors: [
            '#5f7c87',
            '#6f8690',
            '#7f9098',
            '#8f9aa1',
            '#9ea4aa',
            '#a89f9e',
            '#B1A0A1',
            '#c48f72',
            '#d2874c',
            '#e07f26',
            '#ee7700',
          ],
        },
      },
      heatmap: {
        colorLegend: {
          title:
            chart.y_columns?.[0]?.column_name?.toUpperCase() ||
            chart.aggregation_op?.toUpperCase() ||
            '',
        },
      },
      experimental: true,
      axes: {
        bottom: {
          title:
            chart.x_label?.toUpperCase() ??
            xAgg?.toUpperCase() ??
            chart.y_columns?.[0]?.column_name?.toUpperCase() ??
            '',
          mapsTo: 'key',
          scaleType: 'labels',
          ticks: { enabled: false },
        },
        left: {
          title:
            chart.y_label?.toUpperCase() ??
            yAgg?.toUpperCase() ??
            chart.y_columns?.[1]?.column_name?.toUpperCase() ??
            '',
          mapsTo: 'group',
          scaleType: 'labels',
          ticks: { enabled: false },
        },
      },
      toolbar: false,
    };
  }
);